import Falcon from './falcon';
import Stellarus from './stellarus';
import Narukami from './narukami';
import Serenith from './serenith';
import Welkin from './welkin';
import Inferno from './inferno';
import Tricera from './tricera';
import Luminae from './luminae';
import Panther from './panther';
import Alphard from './alphard';

export const MECHA_INFO = [
  {
    id: 'alphard',
    name: '阿尔法特装机',
    component: Alphard
  },
  {
    id: 'panther',
    name: '黑豹特装机',
    component: Panther
  },
  {
    id: 'luminae',
    name: '卢米纳尔特装机',
    component: Luminae
  },
  {
    id: 'inferno',
    name: '地狱火特装机',
    component: Inferno
  },
  {
    id: 'tricera',
    name: '三角龙特装机',
    component: Tricera
  },
  {
    id: 'welkin',
    name: '赤霄特装机',
    component: Welkin
  },
  {
    id: 'narukami',
    name: '鸣神特装机',
    component: Narukami
  },
  {
    id: 'serenith',
    name: '白虹特装机',
    component: Serenith
  },
  {
    id: 'stellarus',
    name: '飞景特装机',
    component: Stellarus
  },
  {
    id: 'falcon',
    name: '矛隼特装机',
    component: Falcon
  }
];
